import Tooltip from "@mui/material/Tooltip";
import axios from "axios";
import moment from "moment";
import AppDatePicker from "../../components/Common/AppDatePicker";
import calendar from "../../assets/icons/calendar.svg";
import React, { useEffect, useRef, useState, useMemo } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { useDispatch, useSelector } from "react-redux";
import deleteIcon from "../../assets/icons/Bin.svg";
import AddButton from "../../assets/icons/Card Add button.svg";
import downarrow from "../../assets/icons/downarrow.svg";
import CalendarView from "../../components/Common/CalendarView";
import AddTaskModal from "../../components/Dailogs/AddTaskModal";
import TaskDelete from "../../components/Dailogs/TaskDelete";
import TaskErrorPopup from "../../components/Dailogs/TaskErrorPopup";
import Header from "../../layouts/Header";
import { Modal } from "react-bootstrap";
import { useParams, useLocation } from "react-router-dom";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";
import { Progress } from "antd";
import {
  CheckCircleOutlined,
  CheckCircleFilled,
  SyncOutlined,
  CheckOutlined,
} from "@ant-design/icons";
import Kebab from "../../assets/icons/Kebab Calculations.svg";
import layer from "../../assets/icons/layers2.svg";
import xCircle from "../../assets/icons/x-circle.svg";
import checked from "../../assets/icons/Checked.svg";
import rightArrow from "../../assets/icons/Right arrow.svg";

import {
  AddComments,
  deleteTask,
  fetchTask,
  fetchTaskByCompanyId,
  updateTask,
  deleteTaskIdFromTimer,
  updateOrdersIndexPositions,
  GlobalRequest,
  ChangeStatus,
  UpdateTimeSession,
  GetActiveTimeSessionOnPlanboard,
  UpdateUserFilter,
} from "../../redux/actions/action";
import {
  API_URL,
  DELETE_TASK,
  CHANGE_STATUS,
} from "../../redux/constants/type";
import "../../assets/styles/local/planBoard.css";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import TaskFilterPopUp from "../../components/TaskFilter/TaskFilterPopUp";
import TaskFilter from "../../components/TaskFilter/TaskFilter";
import Loader from "../../components/Dailogs/Loader";
import { ROLES } from "../../utils/helpers/userRole";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import CurrentWeeksDates from "../../components/Common/CurrentWeeksDates";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { handleGeneralNotification } from "../../utils/helpers/notifications";

const PlanBoard = () => {
  const location = useLocation();
  const { taskId } = useParams();
  const { taskIds } = useParams();
  const dispatch = useDispatch();
  const textAreaRef = useRef("");

  const roleAccess = window.localStorage.getItem("roleid");
  const companyId = window.localStorage.getItem("companyid");
  const TaskId = window.localStorage.getItem("taskid");
  const userId = window.localStorage.getItem("userid");
  const userName = window.localStorage.getItem("firstname");
  const primaryColor = window.localStorage.getItem("primarycolor");
  const packageID = window.localStorage.getItem("packageId");
  const highlightTaskID = window.localStorage.getItem("highlightTaskID");
  const trackingTaskId = window.localStorage.getItem("trackingTaskId");

  const savedIsDateRange = localStorage.getItem("isDateRange") === "1";

  const fetchTasksResponse = useSelector(
    (state) => state.user.fetchTasksResponse,
  );
  const fetchTaskResponse = useSelector(
    (state) => state.user.fetchTaskResponse,
  );
  const updateTaskResponse = useSelector(
    (state) => state.user.updateTaskResponse,
  );
  const addTaskResponse = useSelector((state) => state.user.addTaskResponse);
  const deleteTaskResponse = useSelector(
    (state) => state.user.deleteTaskResponse,
  );
  const getTaskStatusListRes = useSelector(
    (state) => state.user.getTaskStatusListRes,
  );
  const showAdvancedTaskSystem = useSelector(
    (state) => state.user.showAdvancedTaskSystem,
  );
  const changeStatus = useSelector((state) => state.user.changeStatus);
  const addCommentsRes = useSelector((state) => state.user.addComments);

  const StopTimerFromHeaderResponse = useSelector(
    (state) => state.user.StopTimerFromHeaderResponse,
  );
  const OpenTimerFromHeaderResponse = useSelector(
    (state) => state.user.OpenTimerFromHeaderResponse,
  );

  const { changeStageNameRes, createSectionRes } = useSelector(
    (state) => state.user,
  );

  const taskModalCommentDeleteRes = useSelector(
    (state) => state.user.taskModalCommentDeleteRes,
  );

  const UpdateTimeSessionResponse = useSelector(
    (state) => state.user.UpdateTimeSessionResponse,
  );

  const GetActiveTimeSessionOnPlanboardResponse = useSelector(
    (state) => state.user.GetActiveTimeSessionOnPlanboardResponse,
  );

  const [toggledOff, setToggledOff] = useState(
    localStorage.getItem("isDateRange") !== "1",
  );
  const [highlightTask, setHighlightTask] = useState(false);
  const [taggedUser, setTaggedUser] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [allTasks, setAllTasks] = useState([]);
  const [dropStatusId, setDropStatusId] = useState("");
  const [taskid, setTaskid] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [enablecomm, setEnableComm] = useState(false);
  const [showcmnt, setShowcmnt] = useState(true);
  const [message, setMessage] = useState("");
  const inputFile = React.useRef(null);
  const [imgUrl, setImgUrl] = useState("");
  const [comments, setComments] = useState([]);
  const [maxComments, setMaxComments] = useState([]);
  const [minComments, setMinComments] = useState([]);
  const [showError, setShowError] = useState(false);
  const [show, setShow] = useState([]);
  const [length, setLength] = useState("");
  const [modalFunction, setModalFunction] = useState("");
  const [modalFunctionNoty, setModalFunctionNoty] = useState("");
  const [from, setFrom] = useState(moment().toDate());
  const [toDate, setToDate] = useState(moment().add(7, "days").toDate());
  const [attachMessage, setAttachMessage] = useState("");
  const [modelTypeId, setModelTypeId] = useState("");
  const [activeView, setActiveView] = useState(1);
  // const [filterItem, setFilterItem] = useState({
  //   all: true,
  //   projectId: {},
  //   coWorkerId: {},
  //   teamId: {},
  // });

  const [filterItem, setFilterItem] = useState({
    all: false,
    projectId: {},
    coWorkerId: {
      userid: userId,
    },
    teamId: {},
  });

  const [filterItem2, setFilterItem2] = useState([]);

  const filterPayload2 = filterItem2.map((item) => ({
    filter: item.types,
    subIds: item.id ? [{ ids: item.id }] : [],
  }));

  const [showLoader, setShowLoader] = useState(true);
  const [reRenderAPI, setReRenderAPI] = useState(false);
  const [activeIndex, setActiveIndex] = useState(false);
  const [taskNotFound, setTaskNotFound] = useState(false);
  const [statusList, setStatusList] = useState([]);
  const [statusName, setStatusName] = useState("");
  const [activeStatusId, setActiveStatusId] = useState("");

  const [showNewTaskSystem, setShowNewTaskSystem] = useState(false);

  const [isBasicMember, setIsBasicMember] = useState(false);
  const [isBuildingBlock, setIsBuildingBlock] = useState(false);
  const getAppSideNavOptions = useSelector(
    (state) => state.user.appSideNavOptions,
  );

  // ASC for week dates start
  const [startWeek, setStartWeek] = useState(
    moment().startOf("isoWeek").format(),
  );
  const [endWeek, setEndWeek] = useState(moment().endOf("isoWeek").format());

  let startDate_old = moment(startWeek).format();
  let endDate_old = moment(endWeek).format();

  const startDate = useMemo(() => {
    if (toggledOff) {
      // Uncheck → Last Week + Current Week
      return moment().subtract(1, "week").startOf("isoWeek").format();
    }
    // Check → selected/default current week
    return moment(startWeek).format();
  }, [toggledOff, startWeek]);

  const endDate = useMemo(() => {
    if (toggledOff) {
      // Uncheck → Last Week + Current Week
      return moment().endOf("isoWeek").format();
    }
    // Check → selected/default current week
    return moment(endWeek).format();
  }, [toggledOff, endWeek]);

  // ASC for week dates end

  const headerFilterItem = (item) => {
    setFilterItem(item);
  };

  useEffect(() => {
    if (getAppSideNavOptions && getAppSideNavOptions.length > 0) {
      const isBasicPlan = getAppSideNavOptions.every(
        (x) =>
          x.packageName.toUpperCase() == "BASIC" &&
          x.packageId == process.env.REACT_APP_IS_BASIC,
      );
      setIsBasicMember(isBasicPlan);

      const isBuildingBlockVal = getAppSideNavOptions.every(
        (x) => x.packageId == process.env.REACT_APP_IS_PREMIUM,
      );
      setIsBuildingBlock(isBuildingBlockVal);
    }
  }, [getAppSideNavOptions]);
  let filterPayload = [];
  // Check if only one filter is selected
  if (
    Object.values(filterItem).filter((value) => Object.keys(value).length > 0)
      .length === 1
  ) {
    // Find the selected filter type
    const selectedFilterType = Object.keys(filterItem).find(
      (key) => Object.keys(filterItem[key]).length > 0,
    );
    // Process only the selected filter type
    let idKey;
    switch (selectedFilterType) {
      case "projectId":
        idKey = "projectid";
        break;
      case "coWorkerId":
        idKey = "userid";
        break;
      case "teamId":
        idKey = "teamid";
        break;
      default:
        break;
    }
    filterPayload.push({
      filter:
        selectedFilterType === "projectId"
          ? "Projects"
          : selectedFilterType === "coWorkerId"
            ? "Co-Worker"
            : "Teams",
      subIds: filterItem[selectedFilterType][idKey]
        ? [{ ids: filterItem[selectedFilterType][idKey] }]
        : [],
    });
  } else if (filterItem["all"]) {
    // Construct filterPayload with only 'All' filter and empty subIds array
    filterPayload.push({
      filter: "All",
      subIds: [],
    });
  } else {
    // Process selected filters
    Object.keys(filterItem).forEach((key) => {
      if (filterItem[key] && Object.keys(filterItem[key]).length > 0) {
        let filterName;
        let idKey; // Variable to store the key to be used for subIds
        switch (key) {
          case "projectId":
            filterName = "Projects";
            idKey = "projectid";
            break;
          case "coWorkerId":
            filterName = "Co-Worker";
            idKey = "userid";
            break;
          case "teamId":
            filterName = "Teams";
            idKey = "teamid";
            break;
          default:
            break;
        }
        filterPayload.push({
          filter: filterName,
          subIds: filterItem[key][idKey]
            ? [{ ids: filterItem[key][idKey] }]
            : [],
        });
      }
    });
  }
  if (filterPayload.length === 0) {
    filterPayload.push({
      filter: "All",
      subIds: [],
    });
  }

  // useEffect(() => {
  //   setShowNewTaskSystem(showAdvancedTaskSystem);
  // }, [showAdvancedTaskSystem]);

  useEffect(() => {
    if (companyId === "28830f30-b321-4662-a576-f23451677742") {
      setShowNewTaskSystem(false);
    } else {
      if (
        packageID === process.env.REACT_APP_IS_PREMIUM ||
        packageID === process.env.REACT_APP_IS_SPIRE_LITE
      ) {
        setShowNewTaskSystem(true);
      }
    }
  }, [packageID, companyId]);

  const onButtonClick = () => {
    inputFile.current.click();
  };
  const [fetchTransPlanBoadList, setFetchTransPlanBoadList] = useState({});
  const t = (key) => fetchTransPlanBoadList?.[key] || "";
  const [fetchTransModal, setFetchTransModal] = useState({});
  const tt = (key) => fetchTransModal?.[key] || "";
  const [val, setVal] = useState("");

  useEffect(() => {
    fetchScreenTranslations("Planboard-List").then((res) => {
      setFetchTransPlanBoadList(res);
    });
    dispatch(
      GlobalRequest({
        url: `${API_URL}/api/Stage/GetTaskStatusDropdownList`,
        method: "get",
        state: "getTaskStatusListRes",
        data: {},
      }),
    );
    document.addEventListener("click", () => {
      let deleteBtn = document.getElementById("delete-tooltip");
      if (!deleteBtn) {
        setOpen(false);
        setDeleteDiv(null);
        setAscid(null);
      }
    });
  }, [changeStageNameRes]);

  useEffect(() => {
    if (getTaskStatusListRes?.status === true) {
      setStatusList(getTaskStatusListRes?.data);
    }
  }, [getTaskStatusListRes]);

  useEffect(() => {
    if (taskId) {
      setModalFunction("update");
      setTaskid(taskId);
      setShowModal(true);
      setReRenderAPI(true);
    }
  }, [taskId]);

  useEffect(() => {
    if (taskIds) {
      setModalFunction("update");
      setTaskid(taskIds);
      setShowModal(true);
      setReRenderAPI(true);
    }
  }, [taskIds]);

  useEffect(() => {
    fetchScreenTranslations("Update-Co-Worker").then((res) => {
      setFetchTransModal(res);
    });
  }, []);

  // "Update-Co-Worker"

  const handleFileChange = (data) => {
    setImgUrl(data.link);
    setAttachMessage(`${data.name} File is Attached in comment box`);
  };

  const handleAddComments = (attachmentUrl) => {
    dispatch(
      AddComments(userId, taskid, val, "task", attachmentUrl, taggedUser),
    );

    setTaggedUser([]);
    setMessage("");
    setVal("");
    setImgUrl("");
  };

  useEffect(() => {
    if (addCommentsRes.status === true) {
      console.log("asc comm res", addCommentsRes);
      dispatch(fetchComments(taskid));
    }
  }, [addCommentsRes]);

  const fetchComments2 = async (taskId) => {
    // Old Fun.
    await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchComments`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        relatedtoid: taskId,
        type: "task",
      },
    }).then((response) => {
      setComments(response.data);
    });
  };

  const fetchComments = (taskId) => async (dispatch) => {
    // New Fun.
    try {
      const response = await axios({
        method: "post",
        url: `${API_URL}/api/User/FetchComments`,
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          relatedtoid: taskId,
          type: "task",
        },
      });
      dispatch(setComments(response.data));
    } catch (error) {
      console.error("Error fetching comments:", error);
    }
  };

  useEffect(() => {
    if (taskid) {
      // fetchComments(taskid);
      dispatch(
        fetchComments(taskid.includes(".") ? taskid.split(".")[1] : taskid),
      );
    }
  }, [taskid, taskModalCommentDeleteRes]);

  useEffect(() => {
    if (changeStageNameRes?.status === true) {
      fetchTasksBasedOnFilter(searchText, startDate, endDate, filterPayload2);
      setActiveIndex(null);
    }
  }, [changeStageNameRes]);

  useEffect(() => {
    if (createSectionRes?.status === true) {
      fetchTasksBasedOnFilter(searchText, startDate, endDate, filterPayload2);
      setActiveIndex(null);
    }
  }, [createSectionRes]);

  useEffect(() => {
    if (TaskId) {
      setReRenderAPI(true);
      setShowModal(true);
      setTaskid(TaskId);
      setModalFunctionNoty("Notification");
      setModalFunction("Notification");
    }
    setTimeout(() => {
      window.localStorage.removeItem("taskid");
    }, 5000);

    return () => {
      window.localStorage.removeItem("taskid");
    };
  }, []);

  const fetchTasksBasedOnFilter = (
    searchText,
    startDate,
    endDate,
    filterPayload2,
  ) => {
    // setShowLoader(true);
    dispatch(
      fetchTaskByCompanyId(
        companyId,
        searchText,
        startDate,
        endDate,
        filterPayload2,
      ),
    );
  };

  useEffect(() => {
    fetchTasksBasedOnFilter(searchText, startDate, endDate, filterPayload2);
  }, [searchText, startDate, endDate, filterItem2, activeView]);

  useEffect(() => {
    if (StopTimerFromHeaderResponse.length > 0) {
      setModalFunction("update");
      setTaskid(StopTimerFromHeaderResponse);
      setShowModal(true);
      setReRenderAPI(true);
    }
  }, [StopTimerFromHeaderResponse]);

  useEffect(() => {
    if (OpenTimerFromHeaderResponse.length > 0) {
      setModalFunction("update");
      setTaskid(OpenTimerFromHeaderResponse);
      setShowModal(true);
      setReRenderAPI(true);
      dispatch(deleteTaskIdFromTimer());
    }
  }, [OpenTimerFromHeaderResponse]);

  const initialRender5 = React.useRef(true);
  React.useEffect(() => {
    if (!initialRender5.current) {
      if (comments != null) {
        if (comments.status == true) {
          setMinComments([]);
          setShow(comments.data);
          setLength(comments.data.length);
          for (var i = 0; i < 5; i++) {
            minComments.push(comments.data[i]);
          }
          setMaxComments(minComments.filter((item) => item != undefined));
        } else {
        }
      }
    } else {
      initialRender5.current = false;
    }
  }, [comments]);

  // Scroll to the card if it is highlighted.
  useEffect(() => {
    if (highlightTask && highlightTaskID) {
      const targetElement = document.getElementById(`task-${highlightTaskID}`);
      targetElement?.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [highlightTask, highlightTaskID]);

  useEffect(() => {
    if (location.pathname !== "planboard") {
      localStorage.removeItem("highlightTaskID");
    }
  }, []);

  useEffect(() => {
    if (fetchTasksResponse?.status === true) {
      setHighlightTask(true);
      setModalShow(false);
      let taskDetails = fetchTasksResponse.data[0]?.taskstatus;
      let length = 0;
      taskDetails.map((item) => {
        length += item.taskdetails?.[0]?.tasks?.length || 0;
      });
      if (!length && searchText) setTaskNotFound(true);
      else if (length) setTaskNotFound(false);
      setAllTasks(taskDetails);
      let completedTasks = taskDetails?.filter((x) => x.isCompleted == true);
      if (completedTasks && openItems.length == 0) {
        let weeks = completedTasks[0]?.taskdetails.map((x) => x.weekNumber);
        let lastWeek = weeks && Math.max(...weeks);
        if (lastWeek) {
          setOpenItems([lastWeek]);
        }
      }
      if (completedTasks) {
        // for open complete box when drag to there.
        let weeks = completedTasks[0]?.taskdetails.map((x) => x.weekNumber);
        let lastWeek = weeks && Math.max(...weeks);
        if (lastWeek) {
          setOpenItems([lastWeek]);
        }
      }

      setTimeout(() => {
        setShowLoader(false);
      }, 1000);

      setTimeout(() => {
        setHighlightTask(false);
      }, 2000);
    } else {
      setAllTasks([]);
    }
  }, [fetchTasksResponse, filterItem2]);

  // when switch for calendar view, loader off start.
  useEffect(() => {
    // setShowLoader(false);
  }, [activeView === 2]);
  // when switch for calendar view, loader off end.

  React.useEffect(() => {
    if (updateTaskResponse?.status === true) {
      dispatch({ type: "UPDATE_TASK", data: {} });
    }
    if (addTaskResponse?.status === true) {
      dispatch({ type: "ADD_TASK", data: {} });
    }
  }, [updateTaskResponse, addTaskResponse]);

  const [asc, setAsc] = useState([]);

  const flattenTaskDetails = (taskdetails) =>
    taskdetails?.flatMap((week, weekIndex) =>
      (week?.tasks || []).map((task, taskIndex) => ({
        task,
        weekIndex,
        taskIndex,
      })),
    ) || [];

  const unflattenTaskDetails = (originalDetails, flattened) => {
    if (!originalDetails || !originalDetails.length) {
      return [
        {
          weekNumber: 1,
          tasks: reorderTickets(
            flattened.map((item) => item.task),
            null,
            null,
          ),
        },
      ];
    }

    let offset = 0;
    const rebuilt = originalDetails.map((week) => {
      const count = week?.tasks?.length || 0;
      const tasks = flattened
        .slice(offset, offset + count)
        .map((item) => item.task);
      offset += count;
      return {
        ...week,
        tasks: reorderTickets(tasks, null, null),
      };
    });

    if (offset < flattened.length) {
      const extraTasks = flattened.slice(offset).map((item) => item.task);
      if (rebuilt.length === 0) {
        rebuilt.push({
          weekNumber: 1,
          tasks: reorderTickets(extraTasks, null, null),
        });
      } else {
        rebuilt[rebuilt.length - 1].tasks = reorderTickets(
          [...rebuilt[rebuilt.length - 1].tasks, ...extraTasks],
          null,
          null,
        );
      }
    }

    return rebuilt;
  };

  const moveWithinTaskDetails = (
    taskdetails,
    sourceIndex,
    destinationIndex,
  ) => {
    const flattened = flattenTaskDetails(taskdetails);
    if (sourceIndex === destinationIndex) return taskdetails;
    const [moving] = flattened.splice(sourceIndex, 1);
    flattened.splice(destinationIndex, 0, moving);
    return unflattenTaskDetails(taskdetails, flattened);
  };

  const moveBetweenTaskDetails = (
    sourceDetails,
    destDetails,
    sourceIndex,
    destinationIndex,
  ) => {
    const sourceFlat = flattenTaskDetails(sourceDetails);
    const destFlat = flattenTaskDetails(destDetails);
    const [moving] = sourceFlat.splice(sourceIndex, 1);
    destFlat.splice(destinationIndex, 0, moving);

    return {
      sourceTaskdetails: unflattenTaskDetails(sourceDetails, sourceFlat),
      destTaskdetails: unflattenTaskDetails(destDetails, destFlat),
    };
  };

  const onDragEnd = async (result, columns, setColumns) => {
    if (!result.destination) return;
    const { source, destination, draggableId } = result;

    setDropStatusId(columns[destination.droppableId].statusid);

    const sourceColumn = columns[source.droppableId];
    const destColumn = columns[destination.droppableId];
    let sourceItems = [...sourceColumn?.taskdetails];
    let destItems = [...destColumn?.taskdetails];

    const cleanTaskId = draggableId.includes(".")
      ? draggableId.split(".")[1]
      : draggableId;

    setTaskid(draggableId);
    dispatch(fetchTask(cleanTaskId));

    const compareID = cleanTaskId;
    let compareData = allTasks.flatMap((x) =>
      x?.taskdetails.flatMap((y) =>
        y?.tasks.filter((z) => z.taskid === compareID),
      ),
    );
    setAsc(compareData);

    dispatch(
      ChangeStatus(compareID, columns[destination.droppableId].statusid),
    );

    if (source.droppableId !== destination.droppableId) {
      const moved = moveBetweenTaskDetails(
        sourceItems,
        destItems,
        source.index,
        destination.index,
      );
      sourceItems = moved.sourceTaskdetails;
      destItems = moved.destTaskdetails;

      setColumns({
        ...columns,
        [source.droppableId]: {
          ...sourceColumn,
          taskdetails: sourceItems,
        },
        [destination.droppableId]: {
          ...destColumn,
          taskdetails: destItems,
        },
      });

      updateOrderIndexPositions([
        ...flattenTaskDetails(sourceItems).map((item) => item.task),
        ...flattenTaskDetails(destItems).map((item) => item.task),
      ]);
    } else {
      sourceItems = moveWithinTaskDetails(
        sourceItems,
        source.index,
        destination.index,
      );
      setColumns({
        ...columns,
        [source.droppableId]: {
          ...sourceColumn,
          taskdetails: sourceItems,
        },
      });
      updateOrderIndexPositions(
        flattenTaskDetails(sourceItems).map((item) => item.task),
      );
    }
  };

  const reorderTickets = (arrTasks, startIndex, endIndex) => {
    // const reordered = Array.from(arrTasks);
    const reordered = arrTasks.filter((x) => x !== null && x !== undefined);
    reordered.forEach((x) => (x.oldIndexPosition = x?.indexPosition));
    if (startIndex != null && endIndex != null) {
      const [removed] = reordered.splice(startIndex, 1);
      reordered.splice(endIndex, 0, removed);
    }
    reordered.forEach(
      (item, index) => (item.indexPosition = reordered.length - 1 - index),
    );
    return reordered;
  };

  const transferAndReorderTickets = (
    taskid,
    sourceTasks,
    destinationTasks,
    sourceIndex,
    destinationIndex,
  ) => {
    const cleanTaskId = taskid?.includes(".") ? taskid.split(".")[1] : taskid;
    const [movingTask] = sourceTasks.filter((t) => t.taskid === cleanTaskId);
    sourceTasks.splice(sourceIndex, 1);
    if (destinationIndex !== null && destinationIndex !== undefined) {
      destinationTasks.splice(destinationIndex, 0, movingTask);
    } else {
      destinationTasks.push(movingTask);
    }
    return {
      sourceTasks: reorderTickets(sourceTasks, null, null),
      destinationTasks: reorderTickets(destinationTasks, null, null),
    };
  };

  const updateOrderIndexPositions = (arr) => {
    const olnyUpdatedTasks = Array.from(arr).filter(
      (x) => x.oldIndexPosition !== x.indexPosition,
    );
    const payload = olnyUpdatedTasks.map((item) => {
      return { taskid: item.taskid, indexPosition: item.indexPosition };
    });
    dispatch(updateOrdersIndexPositions(payload));
  };

  const [modalShow, setModalShow] = useState(false);
  const [deleteDiv, setDeleteDiv] = useState(false);
  const [ascid, setAscid] = useState(false);
  const [taskId2, setTaskId2] = useState(null);
  const [open, setOpen] = React.useState(false);
  const [popups, setPopups] = useState(false);
  const history = useHistory();

  useEffect(() => {
    if (UpdateTimeSessionResponse?.status === true) {
      dispatch(
        GetActiveTimeSessionOnPlanboard(
          window.localStorage.getItem("userid"),
          moment(new Date()).format("DD/MM/YYYY"),
          `${new Date().getHours().toString().padStart(2, "0")}:${new Date()
            .getMinutes()
            .toString()
            .padStart(2, "0")}:${new Date()
            .getSeconds()
            .toString()
            .padStart(2, "0")}`,
        ),
      );
    }
  }, [UpdateTimeSessionResponse]);

  const handleDelete = (e) => {
    if (
      trackingTaskId &&
      GetActiveTimeSessionOnPlanboardResponse?.data?.taskId === taskId2
    ) {
      dispatch(
        UpdateTimeSession(
          trackingTaskId,
          moment().format("DD/MM/YYYY"),
          moment().format("HH:mm:ss"),
        ),
      );
    }

    if (UpdateTimeSessionResponse?.status === true) {
      dispatch(deleteTask(taskId2));
    } else {
      dispatch(deleteTask(taskId2));
    }
    setModalShow(false);
  };

  useEffect(() => {
    if (deleteTaskResponse?.status === true) {
      // handleGeneralNotification({ notificationType: "CUSTOM", text: "The task is deleted." }, false);
      dispatch({ type: DELETE_TASK, data: {} });
      dispatch(
        fetchTaskByCompanyId(
          companyId,
          searchText,
          startDate,
          endDate,
          filterPayload2,
        ),
      );
    }
  }, [deleteTaskResponse]);

  useEffect(() => {
    if (changeStatus.status === true) {
      handleGeneralNotification(
        {
          notificationType: "CUSTOM",
          text: `${userName} moved ${changeStatus?.data?.taskname} to ${changeStatus?.data?.statusname}`,
        },
        false,
      );
      // dispatch({ type: DELETE_TASK, data: {} });
      dispatch(
        fetchTaskByCompanyId(
          companyId,
          searchText,
          startDate,
          endDate,
          filterPayload2,
        ),
      );
      dispatch({ type: CHANGE_STATUS, data: {} });
    }
  }, [changeStatus]);

  const [openItems, setOpenItems] = useState([]);

  useEffect(() => {
    if (reRenderAPI == false) {
      fetchTasksBasedOnFilter(searchText, startDate, endDate, filterPayload2);
    }
  }, [reRenderAPI]);

  const getInitials = (name) => {
    if (!name || name.length === 0 || typeof name !== "string") {
      return " ";
    }
    const hasSpace = name.includes(" ") && name.split(" ")[1]?.length > 0;
    if (hasSpace) {
      const initials = name
        .split(" ")
        .map((word) => word.charAt(0))
        .join("")
        .toUpperCase();

      return initials;
    } else {
      return name.slice(0, 2).toUpperCase();
    }
  };

  // console.log(
  //   "asc43 all",
  //   allTasks.map((x) => x.taskdetails.map((y) => y.tasks.map((z) => z)))
  // );

  // let ascTask = allTasks
  //   .map((x) => x.taskdetails.map((y) => y.tasks.map((z) => z)))
  //   .flat(2); // This will flatten the array structure by two levels.

  // console.log("asc43 ascTask",ascTask)

  const RenderTasksList = ({ tasks = [], column, weekIndex }) => {
    return tasks?.map((task, index) => {
      return (
        <Draggable
          key={`draggable-${task?.taskid}`}
          draggableId={`${weekIndex}${task?.taskid}`}
          index={index}
        >
          {(provided, snapshot) => {
            const isExpired =
              Date.now() >
              new Date(task?.endDate).getTime() - 2 * 24 * 60 * 60 * 1000;
            return (
              <>
                {!task ? (
                  "Updating Please wait..."
                ) : (
                  <div
                    onContextMenu={(e) => {
                      e.preventDefault();
                      setDeleteDiv((prev) => !prev);
                      setAscid(task.taskid);
                    }}
                    // className="task-single-card-planBoard h-auto"
                    // className={
                    //   highlightTask && highlightTaskID === task?.taskid
                    //     ? "task-single-card-highlight h-auto"
                    //     : "task-single-card-planBoard h-auto"
                    // }
                    className={`${
                      highlightTask && highlightTaskID === task?.taskid
                        ? "task-single-card-highlight h-auto"
                        : "task-single-card-planBoard h-auto"
                    } ${isExpired ? "expired-task" : ""}`}
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    onClick={() => {
                      setModalFunction("update");
                      setTaskid(task?.taskid);
                      setShowModal(true);
                      setReRenderAPI(true);
                      setModelTypeId(column?.statusid);
                      setStatusName(column?.statusname);
                      localStorage.setItem("highlightTaskID", task?.taskid);
                    }}
                  >
                    <div
                      className="task-card-color"
                      style={{
                        backgroundColor:
                          column?.statusid ===
                            process.env.REACT_APP_PROJECT_SALES_PIPELINE ||
                          column?.statusid ===
                            "08dab011-a6cf-4069-887e-83e5f3473108" ||
                          column?.statusid ===
                            "08dab011-a6cf-4069-887e-83e5f3473108" ||
                          column?.statusid ===
                            process.env.REACT_APP_PROJECT_FOR_PODUCTION
                            ? "#e9e9e9"
                            : task?.priorityid ===
                                process.env.REACT_APP_TASK_PRIORITY_EXTREME
                              ? "#F76767"
                              : task?.priorityid ===
                                  process.env.REACT_APP_TASK_PRIORITY_HIGH
                                ? "#95A7C6"
                                : task?.priorityid ===
                                    process.env.REACT_APP_TASK_PRIORITY_LOW
                                  ? "#EAEAEA"
                                  : task?.priorityid ===
                                      process.env.REACT_APP_TASK_PRIORITY_NORMAL
                                    ? " #D2DCE9"
                                    : "#D2DCE9",
                      }}
                    ></div>

                    <div className="task-card-content-plan">
                      <Progress
                        className=""
                        strokeColor="#95A7C6"
                        percent={
                          // task?.estimatedTime
                          //   ? Math.floor(
                          //       (Number(
                          //         task?.consumedTime
                          //           .toString()
                          //           .split(".")[0]
                          //           ?.padStart(2, "0"),
                          //       ) /
                          //         parseFloat(task?.estimatedTime)) *
                          //         100,
                          //     )
                          //   : "0"

                          task?.estimatedTime
                            ? (
                                ((Number(
                                  task?.consumedTime?.toString().split(".")[0],
                                ) *
                                  60 +
                                  Number(
                                    task?.consumedTime
                                      ?.toString()
                                      .split(".")[1] || 0,
                                  )) /
                                  (Number(task?.estimatedTime) * 60)) *
                                100
                              ).toFixed(1)
                            : "0"
                        }
                        // format={(percent) => `${percent}% Hours`}
                        format={(percent) => (
                          <span style={{ color: "#5B5B5B" }}>
                            {percent}% Hours
                          </span>
                        )}
                      />
                      <div className="task-card-details-grid">
                        <div className="ps-1">
                          <p
                            className="task-card-task-name task-name-wrappe-r"
                            title={
                              task?.taskname?.length > 10 && task?.taskname
                            }
                          >
                            {task?.taskname}
                            {/* {task?.taskname ? task?.taskname : "Loading..."} */}
                          </p>
                        </div>

                        <div
                          style={{
                            textAlign: "end",
                            display: "flex",
                            justifyContent: "end",
                            height: "fit-content",
                          }}
                        >
                          {task?.assigneedetail?.length > 3 && (
                            <div
                              className="task-card-image"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                backgroundColor: "#00246A",
                                border: "none",
                                color: "#FFFFFF",
                                cursor: "pointer",
                                fontSize: "14px",
                                fontWeight: "bolder",
                              }}
                            >
                              +{task?.assigneedetail?.length - 3}
                            </div>
                          )}

                          {task?.assigneedetail?.length <= 3 &&
                            task?.assigneedetail?.map((assignee, i) => {
                              const hasImageUrl =
                                assignee.imageurl &&
                                assignee.imageurl.length > 0;

                              return (
                                <div
                                  key={`assignee-${i}`}
                                  className="assignee-container"
                                >
                                  {hasImageUrl ? (
                                    <img
                                      alt=""
                                      className="task-card-image"
                                      src={assignee?.imageurl}
                                      style={{
                                        border: `2px ${primaryColor} solid`,
                                      }}
                                    />
                                  ) : (
                                    <div
                                      className="assignee-container"
                                      style={{
                                        marginLeft: "-8px",
                                        border: "2px solid white",
                                        backgroundColor: "#95A7C6",
                                        height: "38px",
                                        width: "38px",
                                        borderRadius: "50px",
                                        color: "white",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontWeight: "500",
                                      }}
                                    >
                                      {getInitials(assignee?.assigneeName)}
                                    </div>
                                  )}
                                </div>
                              );
                            })}

                          {task?.assigneedetail?.length > 3 &&
                            task?.assigneedetail?.map((assignee, i) => {
                              const hasImageUrl =
                                assignee?.imageurl &&
                                assignee?.imageurl?.length > 0;

                              return (
                                i < 3 && (
                                  <div
                                    key={`assignee-${i}`}
                                    className="assignee-container"
                                  >
                                    {hasImageUrl ? (
                                      <img
                                        alt=""
                                        className="task-card-image"
                                        src={assignee?.imageurl}
                                        style={{
                                          border: `2px ${primaryColor} solid`,
                                        }}
                                      />
                                    ) : (
                                      <div
                                        className="assignee-container"
                                        style={{
                                          marginLeft: "-8px",
                                          border: "2px solid white",
                                          backgroundColor: "#95A7C6",
                                          height: "38px",
                                          width: "38px",
                                          borderRadius: "50px",
                                          color: "white",
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          fontWeight: "500",
                                        }}
                                      >
                                        {getInitials(assignee?.assigneeName)}
                                      </div>
                                    )}
                                  </div>
                                )
                              );
                            })}
                        </div>
                      </div>

                      <div
                        className="task-card-sub-name"
                        style={{ maxHeight: "max-content", maxWidth: "270px" }}
                      >
                        <p
                          className="mb-0 text-truncate"
                          // title={task?.taskdescription}
                          title={task?.taskdescription
                            ?.replace(/<[^>]+>/g, "") // remove html tags
                            ?.replace(/&nbsp;/g, " ")}
                        >
                          {/* {task?.taskdescription?.length > 35
                            ? task?.taskdescription?.slice(0, 35) + "..."
                            : task?.taskdescription} */}

                          {task?.taskdescription
                            ?.replace(/<[^>]+>/g, "")
                            ?.replace(/&nbsp;/g, " ")
                            ?.slice(0, 35)}
                          {task?.taskdescription?.replace(/<[^>]+>/g, "")
                            ?.length > 35 && "..."}
                        </p>

                        <p className="mb-0">{task?.projectcode}</p>
                        <p className="mb-0">{task?.projectname}</p>

                        <p className="mb-0">
                          {task?.contactdetail?.clientdetail?.clientname ==
                            null || undefined
                            ? task?.contactdetail?.contactname
                            : task?.contactdetail?.clientdetail?.clientname}
                        </p>

                        <p className="mb-0">
                          {moment(task?.endDate).format("DD.MM.YYYY")}
                        </p>
                      </div>
                      <div></div>
                    </div>
                  </div>
                )}

                {deleteDiv && ascid === task?.taskid && (
                  <Tooltip
                    PopperProps={{
                      disablePortal: true,
                    }}
                    open={ascid === task?.taskid ? open : setOpen(false)}
                    disableFocusListener
                    disableHoverListener
                    disableTouchListener
                    title="Add"
                    id="delete-tooltip"
                  >
                    <div
                      className={
                        roleAccess === process.env.REACT_APP_IS_VIEWER
                          ? "d-none"
                          : "d-flex justify-content-center ms-auto ascDelete me-2"
                      }
                      style={{ marginTop: "-3rem" }}
                      onClick={() => {
                        setModalShow(true);
                        setTaskId2(task?.taskid);
                        setTimeout(() => {
                          setDeleteDiv(false);
                        }, 1000);
                      }}
                    >
                      <img
                        className="dlticon mt-3 me-2"
                        src={deleteIcon}
                        alt=""
                      />
                      <p className="pt-3 ascDlt">{t("Delete")}</p>
                    </div>
                  </Tooltip>
                )}
              </>
            );
          }}
        </Draggable>
      );
    });
  };

  /// ASC CLOSE DROP DOWN CLICK OUT SIDE START ///
  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (
      startingDate_Popup_Ref.current &&
      !startingDate_Popup_Ref.current.contains(event.target)
    ) {
      setCalendarIsOpen(false);
    }
    if (
      endingDate_Popup_Ref.current &&
      !endingDate_Popup_Ref.current.contains(event.target)
    ) {
      setCalendarIsOpen2(false);
    }
  };
  /// ASC CLOSE DROP DOWN CLICK OUT SIDE END ///

  const startingDate_Popup_Ref = useRef(null);
  const endingDate_Popup_Ref = useRef(null);

  const [startingDate, setStartingDate] = useState(
    localStorage.getItem("isDateRange") === "1"
      ? moment().startOf("isoWeek").toDate()
      : moment().subtract(1, "week").startOf("isoWeek").toDate(),
  );

  const [endingDate, setEndingDate] = useState(
    moment().endOf("isoWeek").toDate(),
  );

  const [calendarIsOpen, setCalendarIsOpen] = useState(false);
  const [calendarIsOpen2, setCalendarIsOpen2] = useState(false);

  return (
    <>
      <Header
        setQuery={setSearchText}
        leftComponent={
          <div
            style={{
              color: "#333333",
              fontSize: "16px",
              lineHeight: "27px",
              fontWeight: "bold",
              display: "flex",
              columnGap: "26px",
              alignItems: "center",
            }}
          >
            {/* {packageID === "df5e8fbd-7374-4048-82c8-61a67c789401" ||
            packageID === "df5e8fbd-7374-4048-82c8-61a67c789402"
              ? "Plan Board"
              : "Tasks"} */}
            {t("Plan Board")}

            {showNewTaskSystem && (
              <div>
                <p className="d-none">
                  <CurrentWeeksDates
                    showWeekNumber={false}
                    setWantStartWeekDates={setStartWeek}
                    setWantEndWeekDates={setEndWeek}
                  />
                </p>

                {/* date filter start */}
                <div className="flexContainer gap-3">
                  {/* toggle */}
                  {toggledOff ? (
                    <CheckCircleOutlined
                      className={"mt- mx-2 pointer"}
                      onClick={() => {
                        setToggledOff(false);

                        // Check = Current Week
                        setStartingDate(moment().startOf("isoWeek").toDate());
                        setEndingDate(moment().endOf("isoWeek").toDate());

                        setStartWeek(moment().startOf("isoWeek").format());
                        setEndWeek(moment().endOf("isoWeek").format());

                        localStorage.setItem("isDateRange", "1");
                        dispatch(UpdateUserFilter({ isDateRange: true }));
                      }}
                    />
                  ) : (
                    <CheckCircleFilled
                      className={"mt- mx-2 pointer"}
                      style={{ color: "#B0DD69" }}
                      onClick={() => {
                        setToggledOff(true);

                        // Uncheck = Last Week + Current Week
                        setStartingDate(
                          moment()
                            .subtract(1, "week")
                            .startOf("isoWeek")
                            .toDate(),
                        );

                        setEndingDate(moment().endOf("isoWeek").toDate());

                        localStorage.setItem("isDateRange", "0");
                        dispatch(UpdateUserFilter({ isDateRange: false }));
                      }}
                    />
                  )}

                  <div
                    className="projectManagerInput ps- flexContainer"
                    id=""
                    style={{
                      width: "35%",
                      border: "none",
                      pointerEvents: toggledOff ? "none" : "",
                    }}
                    // ref={startingDate_Popup_Ref}
                  >
                    <img
                      className="calendarIcon"
                      onClick={() => setCalendarIsOpen((p) => !p)}
                      src={calendar}
                      alt=""
                    />
                    <AppDatePicker
                      open={calendarIsOpen}
                      onOpenChange={(open) => setCalendarIsOpen(open)}
                      inputClassNames={"bg-transparent"}
                      // className="calender-icon-date"
                      selected={startingDate}
                      onChange={(val) => {
                        setStartingDate(val);
                        setStartWeek(val);
                        setCalendarIsOpen(false);
                      }}
                      onSelect={(d, event) => {
                        event.preventDefault();
                      }}
                      // isDisabledForFuture={true}
                      // isDisabledForPast={true}
                      dateFormat="dd/MM/yyyy"
                    />
                  </div>

                  <div
                    className="projectManagerInput ps- flexContainer"
                    style={{
                      width: "35%",
                      border: "none",
                      pointerEvents: toggledOff ? "none" : "",
                    }}
                    // ref={endingDate_Popup_Ref}
                  >
                    <img
                      className="calendarIcon"
                      onClick={() => setCalendarIsOpen2((p) => !p)}
                      src={calendar}
                      alt=""
                    />
                    <AppDatePicker
                      open={calendarIsOpen2}
                      onOpenChange={(open) => setCalendarIsOpen2(open)}
                      inputClassNames={"bg-transparent"}
                      // className="calender-icon-date"
                      selected={endingDate}
                      onChange={(val) => {
                        setEndingDate(val);
                        setEndWeek(val);
                        setCalendarIsOpen2(false);
                      }}
                      onSelect={(d, event) => {
                        event.preventDefault();
                      }}
                      // isDisabledForFuture={true}
                      // isDisabledForPast={true}
                      minDateForPlanBoard={startingDate}
                      dateFormat="dd/MM/yyyy"
                    />
                  </div>
                </div>
                {/* date filter end */}
              </div>
            )}
          </div>
        }
      />

      {reRenderAPI && showModal && (
        <AddTaskModal
          key={modalFunction === "add" ? "add-task" : taskid}
          isBasicMember={isBasicMember}
          isBuildingBlock={isBuildingBlock}
          val={val}
          setVal={setVal}
          textAreaRef={textAreaRef}
          modelTypeId={modelTypeId}
          showModal={showModal}
          modalFunctionNoty={modalFunctionNoty}
          taskid={taskid}
          popups={popups}
          setPopups={setPopups}
          setTaskid={setTaskid}
          setShowModal={(show, reload) => {
            setShowModal(false);
            setModelTypeId("");
            window.localStorage.removeItem("taskid");
            fetchTasksBasedOnFilter(
              searchText,
              startDate,
              endDate,
              filterPayload2,
            );
            history.push(`/planboard`);
          }}
          setComments={setComments}
          modalFunction={modalFunction}
          setModalFunction={setModalFunction}
          setEnableComm={setEnableComm}
          setShowcmnt={setShowcmnt}
          enablecomm={enablecomm}
          showcmnt={showcmnt}
          setMessage={setMessage}
          message={message}
          onButtonClick={onButtonClick}
          handleFileChange={handleFileChange}
          handleAddComments={handleAddComments}
          maxComments={maxComments}
          taggedUser={taggedUser}
          setTaggedUser={setTaggedUser}
          show={show}
          length={length}
          setLength={setLength}
          setShow={setShow}
          attachmentUrl={imgUrl}
          setAttachmentUrl={setImgUrl}
          setMaxComments={setMaxComments}
          from={from}
          searchText={searchText}
          setReRenderAPI={setReRenderAPI}
          statusList={statusList}
          statusName={statusName}
          showNewTaskSystem={showNewTaskSystem}
        />
      )}
      <TaskErrorPopup
        showError={showError}
        setShowError={setShowError}
        setAttachMessage={setAttachMessage}
        attachMessage={attachMessage}
        setImgUrl={setImgUrl}
      />

      {modalShow && (
        <TaskDelete
          animation={true}
          handleDelete={handleDelete}
          show={modalShow}
          onHide={() => setModalShow(false)}
        />
      )}

      <div>
        <div
          className="planBoard"
          style={{
            display: "flex",
            justifyContent: "space-between",
            margin: "0 auto",
            alignItems: "center",
          }}
        >
          <p className="mb-0 ps-md-2 ps-lg-3 ps-xl-2 plan">
            {/* {fetchTransPlanBoadList[0]?.translation} */}
            {/* Tasks */}
          </p>
        </div>
        <div
          className="planBoard plan ps-4 ms-"
          style={{
            display: "flex",
            justifyContent: !isBasicMember ? "space-between" : "end",
            marginLeft: "0 auto",
            alignItems: "baseline",
          }}
        >
          {!isBasicMember && (
            // <TaskFilterPopUp
            //   setFilterItem={setFilterItem}
            //   filterItem={filterItem}
            // />

            <TaskFilter
              setFilterItem2={setFilterItem2}
              filterItem2={filterItem2}
            />
          )}
          {!showNewTaskSystem && (
            <div
              className="kanban-calendar-joint me-5"
              style={{ marginBottom: "2rem" }}
            >
              <p
                className="mb-0 view-k-c"
                onClick={() => setActiveView(1)}
                style={{
                  fontSize: "clamp(14px,0.9vw,0.9vw)",
                  backgroundColor: activeView === 1 ? "#00246A" : "transparent",
                  color: activeView === 1 ? "#FFF" : "#A5A5A5",
                }}
              >
                {t("Karban")}
              </p>
              <p
                className="mb-0 view-k-c"
                onClick={() => setActiveView(2)}
                style={{
                  fontSize: "clamp(14px,0.833vw,0.833vw)",
                  backgroundColor: activeView === 2 ? "#00246A" : "transparent",
                  color: activeView === 2 ? "#FFF" : "#A5A5A5",
                }}
              >
                {t("Calender")}
              </p>
            </div>
          )}
        </div>
        {showLoader ? (
          <div
            className="text-center"
            style={{ color: "#003766", fontSize: "14px", fontWeight: "700" }}
          >
            <Loader />
          </div>
        ) : (
          <>
            {taskNotFound ? (
              <div className="planboard-task-nf">
                Sorry! No results for your criteria. <br /> Try to refine your
                search or enter a new search.
              </div>
            ) : (
              <div className="task-main-box">
                {/* <div className="task-top-grid"> </div> */}
                {activeView === 1 && (
                  <div className="task-grid">
                    <DragDropContext
                      onDragEnd={(result) =>
                        onDragEnd(result, allTasks, setAllTasks)
                      }
                    >
                      {Object.entries(allTasks)?.map(
                        ([columnId, column], index) => {
                          return (
                            <Droppable
                              droppableId={columnId}
                              key={`droppable-${index}`}
                            >
                              {(provided, snapshot) => {
                                return (
                                  <div
                                    className="plan-task-single-line"
                                    key={`droppable-div-${columnId}`}
                                    {...provided.droppableProps}
                                    ref={provided.innerRef}
                                    style={{
                                      borderRadius:
                                        !showNewTaskSystem && "22px",
                                      height:
                                        !showNewTaskSystem &&
                                        "clamp(600px, 41.271vw, 41.271vw)",
                                    }}
                                  >
                                    {showNewTaskSystem &&
                                      !column?.isCompleted && (
                                        <div
                                          className="st-task-main-top-section"
                                          onClick={() => {
                                            setActiveStatusId(column?.statusid);
                                            setActiveView(2);
                                          }}
                                        >
                                          <div
                                            style={{
                                              width: "100%",
                                              backgroundColor: "#fafafa",
                                            }}
                                          ></div>
                                          <div className="st-task-main-top-right">
                                            {/* Sections <img src={rightArrow} /> */}
                                            {t("sections")}{" "}
                                            <img src={rightArrow} />
                                          </div>
                                        </div>
                                      )}
                                    {showNewTaskSystem ? (
                                      <div className="st-task-main-heading">
                                        <div
                                          className="st-task-main-head"
                                          style={{
                                            textTransform: "capitalize",
                                          }}
                                        >
                                          {!column?.isCompleted && (
                                            <img
                                              src={Kebab}
                                              alt=""
                                              style={{ cursor: "pointer" }}
                                              onClick={(e) => {
                                                setActiveIndex(index);
                                                e.stopPropagation(); //like => e.preventDefault.
                                              }}
                                            />
                                          )}
                                          {column.statusname === "To Do"
                                            ? t("To Do")
                                            : column.statusname === "Progress"
                                              ? t("Progress")
                                              : column.statusname === "Complete"
                                                ? t("Complete")
                                                : column.statusname}
                                          {activeIndex === index && (
                                            <EditingStageSection
                                              setActiveIndex={setActiveIndex}
                                              column={column}
                                              setFetchTransPlanBoadList={
                                                setFetchTransPlanBoadList
                                              }
                                              fetchTransPlanBoadList={
                                                fetchTransPlanBoadList
                                              }
                                            />
                                          )}
                                        </div>
                                        {!column?.isCompleted && (
                                          <div
                                            className="st-task-main-btn-div"
                                            style={{
                                              cursor: "pointer",
                                              pointerEvents:
                                                roleAccess ===
                                                  process.env
                                                    .REACT_APP_IS_VIEWER &&
                                                "none",
                                            }}
                                            onClick={() => {
                                              setModalFunction("add");
                                              setShowModal(true);
                                              setModelTypeId(column.statusid);
                                              setStatusName(column?.statusname);
                                              setReRenderAPI(true);
                                            }}
                                          >
                                            <p
                                              className="m-0"
                                              style={{
                                                fontSize: "12px",
                                                color: "#333333",
                                              }}
                                            >
                                              {t("Add Task").split(" ")[0]}
                                              {t("Add Task").split(" ")[1]}
                                            </p>
                                            <img
                                              className="taskImg"
                                              src={AddButton}
                                              alt=""
                                            ></img>
                                          </div>
                                        )}
                                      </div>
                                    ) : (
                                      <div
                                        className="task-main-heading"
                                        style={
                                          companyId ===
                                          "28830f30-b321-4662-a576-f23451677733"
                                            ? {
                                                color: "#6e6f46",
                                                backgroundColor: "#6e6f4633",
                                              }
                                            : companyId ===
                                                "28830f30-b321-4662-a576-f23451677744"
                                              ? {
                                                  color: "#444141",
                                                  backgroundColor: "#02A29B1A",
                                                }
                                              : {
                                                  color: "#A98240",
                                                  backgroundColor: "unset",
                                                }
                                        }
                                      >
                                        <span className="task-main-heading-text d-flex justify-content-between p-4">
                                          <p
                                            className={
                                              column.statusid ===
                                              process.env
                                                .REACT_APP_TASK_STATUS_COMPLETE
                                                ? "d-none"
                                                : roleAccess ===
                                                    process.env
                                                      .REACT_APP_IS_VIEWER
                                                  ? "d-none"
                                                  : "addTask d-flex"
                                            }
                                            onClick={() => {
                                              setModalFunction("add");
                                              setShowModal(true);
                                              setModelTypeId(column.statusid);
                                              setStatusName(column?.statusname);
                                              setReRenderAPI(true);
                                            }}
                                          >
                                            <img
                                              className="me-2 mt-1 taskImg"
                                              src={AddButton}
                                              alt=""
                                            ></img>
                                            <p
                                              style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "flex-start",
                                              }}
                                            >
                                              {t("Add Task").split(" ")[0]}
                                              <span className="mb-0">
                                                {" "}
                                                {t("Add Task").split(" ")[1]}
                                              </span>
                                            </p>
                                          </p>
                                          <p className="text-end ms-auto">
                                            {column.statusname === "To Do"
                                              ? t("To Do")
                                              : column.statusname === "Progress"
                                                ? t("Progress")
                                                : column.statusname ===
                                                    "Complete"
                                                  ? t("Complete")
                                                  : column.statusname}
                                          </p>
                                        </span>
                                      </div>
                                    )}
                                    <div
                                      className="bothDivScroll"
                                      style={{ paddingBottom: "1rem" }}
                                    >
                                      <div className="d-flex flex-column align-items-center gap-3 mt-3">
                                        {Boolean(column.isCompleted) &&
                                          column?.taskdetails?.map(
                                            (week, weekIndex) => {
                                              const isOpen = openItems.includes(
                                                week.weekNumber,
                                              );
                                              return (
                                                <React.Fragment
                                                  key={`weekdata-${weekIndex}`}
                                                >
                                                  <div
                                                    className="groupingDiv"
                                                    onClick={() => {
                                                      if (isOpen) {
                                                        setOpenItems(
                                                          openItems.filter(
                                                            (openItem) =>
                                                              openItem !==
                                                              week.weekNumber,
                                                          ),
                                                        );
                                                      } else {
                                                        setOpenItems([
                                                          ...openItems,
                                                          week.weekNumber,
                                                        ]);
                                                      }
                                                    }}
                                                  >
                                                    <p className="weekNum m-0">
                                                      {t("Week")}{" "}
                                                      {week.weekNumber}
                                                    </p>
                                                    <span>
                                                      <img
                                                        alt=""
                                                        src={downarrow}
                                                        className={
                                                          isOpen
                                                            ? "downarrow ms-5"
                                                            : " uparrow ms-5"
                                                        }
                                                      />
                                                    </span>
                                                  </div>

                                                  {isOpen && (
                                                    <>
                                                      <RenderTasksList
                                                        tasks={
                                                          column?.taskdetails?.[
                                                            weekIndex
                                                          ]?.tasks || []
                                                        }
                                                        column={column}
                                                        weekIndex={`${weekIndex}.`}
                                                      />
                                                      {column?.taskdetails?.[
                                                        weekIndex
                                                      ]?.tasks?.length ===
                                                        0 && (
                                                        <span className="noTask text-muted">
                                                          {t(
                                                            "Week and no tasks in this week",
                                                          )}
                                                        </span>
                                                      )}
                                                    </>
                                                  )}
                                                </React.Fragment>
                                              );
                                            },
                                          )}
                                        {!Boolean(column.isCompleted) && (
                                          <RenderTasksList
                                            tasks={
                                              column?.taskdetails[0].tasks || []
                                            }
                                            column={column}
                                            weekIndex={""}
                                          />
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                );
                              }}
                            </Droppable>
                          );
                        },
                      )}
                    </DragDropContext>
                  </div>
                )}
                {activeView === 2 && (
                  <>
                    {showNewTaskSystem && (
                      <div
                        style={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <div
                          className="st-task-main-top-right"
                          style={{
                            backgroundColor: "#f1f1f1",
                            borderRadius: "6px 6px 0px 0px",
                            width: "126px",
                            height: "33px",
                          }}
                          onClick={() => setActiveView(1)}
                        >
                          {/* Sections{" "} */}
                          {t("sections")}
                          <img
                            src={rightArrow}
                            style={{ transform: "rotate(180deg)" }}
                          />
                        </div>
                      </div>
                    )}
                    <CalendarView
                      setModalFunction={setModalFunction}
                      setShowModal={(bln) => {
                        setReRenderAPI(true);
                        setShowModal(bln);
                        setModelTypeId(process.env.REACT_APP_TASK_STATUS_TODO);
                      }}
                      setTaskid={setTaskid}
                      filterItem={filterItem}
                      showNewTaskSystem={showNewTaskSystem}
                      activeStatusId={activeStatusId}
                      headerDate={startDate}
                    />
                  </>
                )}
              </div>
            )}
          </>
        )}
      </div>

      {popups && (
        <Modal
          backdrop={"static"}
          show={popups}
          className="modelwidth12 modal-dialog-update-mem"
          style={{
            background: "#F2F2F2 0% 0% no-repeat padding-box",
            opacity: "0.95",
            marginTop: "0px",
            // zIndex: 100,
          }}
          id="update-member-modal"
          centered
        >
          <Modal.Body>
            <div className="flex_class my-5">
              <div className="text1">
                {tt("The changes made will not be saved.")}
              </div>

              <div className="mt-4">{tt("Do you want to proceed?")}</div>

              <div className="mt-5 ">
                <button
                  className="me-2  asc_no"
                  onClick={() => {
                    setPopups(false);
                  }}
                  style={{ fontWeight: 800 }}
                >
                  {tt("No")}
                </button>
                <button
                  className="ms-2  asc_yes"
                  onClick={() => {
                    setShowModal(false);
                    setPopups(false);
                    fetchTasksBasedOnFilter(
                      searchText,
                      startDate,
                      endDate,
                      filterPayload2,
                    );
                  }}
                  style={{ fontWeight: 800 }}
                >
                  {tt("Yes")}
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

const EditingStageSection = ({
  setActiveIndex,
  column,
  fetchTransPlanBoadList,
}) => {
  const dispatch = useDispatch();
  const [activeEditSection, setActiveEditSection] = useState(false);
  const [activeAddSection, setActiveAddSection] = useState(false);
  const [editStageName, setEditStageName] = useState("");
  const [editStageId, setEditStageId] = useState("");
  const [newSectionName, setNewSectionName] = useState("");
  const t = (key) => fetchTransPlanBoadList?.[key] || "";

  /// ASC CLOSE DROP DOWN CLICK OUT SIDE START ///
  const kebabRef = useRef();

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (kebabRef.current && !kebabRef.current.contains(event.target)) {
      setActiveIndex(null);
    }
  };
  /// ASC CLOSE DROP DOWN CLICK OUT SIDE END ///

  return (
    <article
      ref={kebabRef}
      className="st-section-edit-pop"
      style={{ top: "0", left: "0", textTransform: "capitalize" }}
    >
      <article className="st-section-edit-pop-div">
        <img
          src={Kebab}
          className="st-section-edit-dots"
          onClick={() => setActiveIndex(null)}
        />
        <article
          className="st-section-edit-line"
          onClick={() => {
            setActiveEditSection(true);
            setActiveAddSection(false);
            setEditStageName(column?.statusname);
            setEditStageId(column?.statusid);
          }}
        >
          <img src={checked} />
          {/* Stage name */}
          {t("stage name")}
        </article>
        <article
          className="st-section-edit-line"
          onClick={() => {
            setActiveEditSection(false);
            setActiveAddSection(true);
            setEditStageId(column?.statusid);
          }}
          style={{
            borderBottomLeftRadius: "8px",
            borderBottomRightRadius: "8px",
          }}
        >
          <img src={layer} />
          {/* Create Section */}
          {t("create section")}
        </article>
      </article>
      {activeEditSection && (
        <article className="st-edit-section-name-pop">
          <img
            src={xCircle}
            style={{
              alignSelf: "end",
              width: "22px",
              height: "22px",
              cursor: "pointer",
            }}
            onClick={() => {
              setEditStageName("");
              setEditStageId("");
              setActiveEditSection(false);
              setActiveAddSection(false);
              setNewSectionName("");
            }}
          />
          <div className="st-single-stage-div" style={{ flexGrow: "0" }}>
            <label
              className="st-single-stage-label"
              style={{
                backgroundColor: "#E4EDFA",
                color: "#7E7E7E",
                fontWeight: "400",
              }}
            >
              {/* Stage Name */}
              {t("stage name")}
            </label>
            <input
              className="st-single-stage-input"
              value={editStageName}
              onChange={(e) => setEditStageName(e.target.value)}
              maxLength={32}
            />
            <div className="st-single-stage-length">
              {editStageName?.length}/32
            </div>
          </div>
          <div
            className="d-flex add-buttons"
            style={{
              borderRadius: "12px",
              minWidth: "100px",
              minHeight: "35px",
              alignSelf: "center",
            }}
            onClick={() =>
              dispatch(
                GlobalRequest({
                  url: `${API_URL}/api/stage/changestagename`,
                  method: "put",
                  state: "changeStageNameRes",
                  data: { statusId: editStageId, statusName: editStageName },
                }),
              )
            }
          >
            <p className="fw-bold mb-0">
              {/* Change */}
              {t("Change")}
            </p>
          </div>
        </article>
      )}
      {activeAddSection && (
        <article
          className="st-edit-section-name-pop"
          style={{
            top: "30%",
          }}
        >
          <img
            src={xCircle}
            style={{
              alignSelf: "end",
              width: "22px",
              height: "22px",
              cursor: "pointer",
            }}
            onClick={() => {
              setEditStageName("");
              setEditStageId("");
              setActiveEditSection(false);
              setActiveAddSection(false);
              setNewSectionName("");
            }}
          />
          <div className="st-single-stage-div" style={{ flexGrow: "0" }}>
            <label
              className="st-single-stage-label"
              style={{
                backgroundColor: "#E4EDFA",
                color: "#7E7E7E",
                fontWeight: "400",
              }}
            >
              {/* Section Name */}
              {t("Section Name")}
            </label>
            <input
              className="st-single-stage-input"
              value={newSectionName}
              onChange={(e) => setNewSectionName(e.target.value)}
              maxLength={32}
            />
            <div className="st-single-stage-length">
              {newSectionName?.length}/32
            </div>
          </div>
          <div
            className="d-flex add-buttons"
            style={{
              borderRadius: "12px",
              minWidth: "100px",
              minHeight: "35px",
              alignSelf: "center",
            }}
            onClick={() =>
              dispatch(
                GlobalRequest({
                  url: `${API_URL}/api/stage/createsection`,
                  method: "post",
                  state: "createSectionRes",
                  data: { statusId: editStageId, sectionName: newSectionName },
                }),
              )
            }
          >
            <p className="fw-bold mb-0">
              {/* Add */}
              {t("Add")}
            </p>
          </div>
        </article>
      )}
    </article>
  );
};

export default PlanBoard;
